import gql from "graphql-tag";

export const CHALLENGE_REGISTRATION_QUERY = gql`
  query challengeRegistrationsQuery($userId: ID) {
    challengeRegistrations(userId: $userId) {
      id
      createdAt
      product {
        id
        name
      }
      challenge {
        id
        title
        description
      }
      nutritionPlan {
        name
        pdf
      }
    }
  }
`;

export const COURSE_REGISTRATION_QUERY = gql`
  query courseRegistrationsQuery($userId: ID!) {
    courseRegistrations(userId: $userId) {
      edges {
        node {
          id
          createdAt
          product {
            id
            name
          }
          course {
            id
            title
          }
        }
      }
    }
  }
`;
